export default __webpack_public_path__ + "static/media/colourlessPT.79bd8700.png";